import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';
import {Link} from 'react-router-dom';
import {getRankUpOrDown, getUserProfileLink} from '../utils/helper';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {deepPurple} from '@mui/material/colors';

export default function LeaderboardTable({rows, selectedRow}) {

  const styleRow = (rowIndex) => {
    if (rowIndex === selectedRow) {
      return {border: '1px solid darkblue', background: 'lightblue'}
    }
    return {}
  }


  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Rank</TableCell>
            <TableCell align="center">Name</TableCell>
            <TableCell align="center">Points</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => {
            const rankDelta = getRankUpOrDown()
            const isUp = rankDelta > 10
            const color = isUp ? 'green' : 'red'

            return <TableRow
              sx={styleRow(row.rank)}
              key={row.rank}
            >
              <TableCell
                component="tr" scope="row"
              >
                <Stack direction={'row'} alignItems="center">
                  {/*bgcolor: deepPurple[500]*/}
                  <Avatar sx={{width: 30, height: 30, bgcolor: deepPurple[500]}}>{row.rank}</Avatar>
                  {/*<Typography variant="h6">*/}
                  {/*    {row.rank}*/}
                  {/*</Typography>*/}
                  <Typography variant="caption" color={color}>
                    {isUp ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                  </Typography>
                  <Typography variant="caption" color={color}>
                    {rankDelta}
                  </Typography>
                </Stack>
              </TableCell>
              <TableCell align="center">
                <Link to={getUserProfileLink()}>{row.name}</Link>

              </TableCell>
              <TableCell align="center">{row.points}</TableCell>
            </TableRow>
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
